<div class="row">
  <div class="col-lg-6">
    <kla-title [lineConfig]="lineConfig" [config]="titleConfig"></kla-title>
  </div>
  <div class="col-sm-12 chart" #panel>
    <kla-line-chart
      *ngIf="chartConfig && chartConfig.visible"
      [width]="chartConfig.width"
      [padding]="chartConfig.width/10"
      [height]="chartConfig.height"
      [currentValues]="chartConfig.currentValues"
      [plannedValues]="chartConfig.plannedValues"
      [image]="chartConfig.image"
      [value]="chartConfig.value"
      [title]="chartConfig.title"
      [descriptions]="chartConfig.descriptions">
    </kla-line-chart>
  </div>
  <div class="col-lg-11 chart" *ngIf="audioConfig">
    <kla-audio class="audio"
               [url]="audioConfig.url"
               [image]="audioConfig.image"
               [text]="audioConfig.text">
    </kla-audio>
  </div>
</div>
